import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { FuelService } from 'src/app/services/fuel.service';
import { TankService } from 'src/app/services/tank.service';
import { Fuel } from 'src/app/shared/models/Fuel';

@Component({
  selector: 'app-list-fuel-page',
  templateUrl: './list-fuel-page.component.html',
  styleUrls: ['./list-fuel-page.component.css']
})
export class ListFuelPageComponent implements OnInit {

  fuels: Fuel[] = [];
  tankName: string;
  tankId: number;
  cost: number;

  constructor(private fuelService: FuelService, private tankService: TankService) {
    /* let fuelObservable: Observable<Fuel[]>
     fuelObservable = fuelService.getAll();
     fuelObservable.subscribe((fuelService) => {
       this.fuels = fuelService;
     })*/
  }

  ngOnInit() {
    this.tankService.getCurrentTank().subscribe((tank) => {
      if (tank) {
        this.tankName = tank.name;
        this.tankId = tank.id;
        this.cost = tank.cost;
        this.listFuels(this.tankId);
      }
    });
  }

  listFuels(tank: number) {
    this.fuelService.getFuelByTank(tank).subscribe(data => {
      console.log(data);
      this.fuels = data;
    }, error => {
      console.log(error);
    })


  }

  deleteFuel(id: any) {
    if (this.fuelService.deleteFuel(id).subscribe(data => {
      this.listFuels(this.tankId);
    }, error => {
      console.log(error);
    })) {
      return;
    }
  }
}
